import React, { useState, useEffect } from 'react';

const styles = {
  banner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'var(--surface)',
    borderTop: '1px solid var(--border)',
    padding: '16px 24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '24px',
    zIndex: 9999,
    boxShadow: '0 -4px 12px rgba(0,0,0,0.05)',
    flexWrap: 'wrap',
  },
  text: {
    fontSize: '13px',
    color: 'var(--text)',
    lineHeight: 1.5,
    maxWidth: '800px',
  },
  buttons: {
    display: 'flex',
    gap: '12px',
  },
  acceptBtn: {
    background: 'var(--accent)',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '6px',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer',
  },
  declineBtn: {
    background: 'transparent',
    color: 'var(--text-muted)',
    border: '1px solid var(--border)',
    padding: '8px 16px',
    borderRadius: '6px',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer',
  }
};

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('convertalldocs_cookie_consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('convertalldocs_cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('convertalldocs_cookie_consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={styles.banner}>
      <div style={styles.text}>
        We use cookies to personalize content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our advertising and analytics partners.
      </div>
      <div style={styles.buttons}>
        <button style={styles.declineBtn} onClick={handleDecline}>Decline</button>
        <button style={styles.acceptBtn} onClick={handleAccept}>Accept All</button>
      </div>
    </div>
  );
}
